import React from "react";

import ViewHeader from "components/ViewHeader";

export default function HomeView() {

  return (
    <div className="HomeView">
      <ViewHeader caption="Home" />
    </div>
  );
}
